<template>
    <b-col :cols="span">
        <div class="mb-3">
            <div class="text-capitalize font-lg font-weight-bold">
                <slot>{{ value }}</slot>
            </div>
            <div class="font-xs">
                {{ name }}
            </div>
        </div>
    </b-col>
</template>

<script>
  export default {
    name: 'CardDetail',

    props: {
      span: {
        type: Number,
        required: true
      },
      name: {
        type: String,
        required: true
      },
      value: {
        type: [String, Number],
        default: ''
      }
    }
  };
</script>
